"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var app_1 = require("../app");
var stripe_js_1 = require("@stripe/stripe-js");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var stripe_elements_1 = __importDefault(require("./stripe_elements"));
var useContext = react_1.default.useContext, useMemo = react_1.default.useMemo;
exports.default = (function (_a) {
    var context = useContext(app_1.CheckoutContext);
    if (!context)
        return null;
    var paymentAuthorizationToken = context.paymentAuthorizationToken;
    var stripePromise = useMemo(function () { return (0, stripe_js_1.loadStripe)(paymentAuthorizationToken); }, []);
    return (react_1.default.createElement(react_stripe_js_1.Elements, { stripe: stripePromise },
        react_1.default.createElement(stripe_elements_1.default, null)));
});
